import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChannelFilterEntity } from '../../domain/entities/ChannelFilterEntity'

export class ChannelFilterModel extends ChannelFilterEntity {
  constructor(dataDto: ChannelFilterEntity) {
    super()
    mapEntityProperties<ChannelFilterModel>(this, dataDto)
  }
}
